import styles from "./styles.module.scss";
import MatchDetailPage from "./widget";

export default MatchDetailPage;
export {styles};